import { all } from 'redux-saga/effects';
import { callToAPIWatcher, userLogoutWatcher, callToAPIWatcherPartner, seedcallToAPIWatcher, createVmcallToAPIWatcher, vmListToAPIWatcher, vmDetailsToAPIWatcher, cohortsListToAPIWatcher, cohortsDetailsToAPIWatcher, cohortsSeedDataToAPIWatcher, cohortsbasicupdateAPIWatcherPartner, UpdateVmAPIWatcherPartner, uploadImgToAPIWatcher, callToAPIWatcherCityData, DeleteVm } from '../Modules/HandleAPICalls/saga';

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([callToAPIWatcher(), seedcallToAPIWatcher(), userLogoutWatcher(), callToAPIWatcherPartner(), createVmcallToAPIWatcher(), vmListToAPIWatcher(), vmDetailsToAPIWatcher(), cohortsListToAPIWatcher(), cohortsDetailsToAPIWatcher(), cohortsSeedDataToAPIWatcher(), cohortsbasicupdateAPIWatcherPartner(), UpdateVmAPIWatcherPartner(), uploadImgToAPIWatcher(), callToAPIWatcherCityData(), DeleteVm()]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js